module.exports = __webpack_public_path__ + "img/pitcher_icon.d6878371.png";